import { AGENT_CALLS_PATH } from '../../constants';

/**
 * `/accounts/:accountId/assistants/:assistantId/inbox/agent-calls` — the only
 * place the page is mounted (`AppRouter.tsx`). Anchored at both ends, so the
 * chats inbox (`/inbox/chats`) and the RTA calls view (`/inbox/calls`,
 * `/inbox/phone-calls`) never match; a plain substring test would also catch an
 * id that happens to contain the segment.
 */
const AGENT_CALLS_ROUTE = new RegExp(`^/accounts/[^/]+/assistants/[^/]+/${AGENT_CALLS_PATH}/?$`);

export function isAgentCallsPath(pathname: string): boolean {
  return AGENT_CALLS_ROUTE.test(pathname);
}
